import { gql } from "@apollo/client";

export const REGISTRAR_DEMORA = gql`
mutation RegistrarDemora($input: RegistrarDemoraInput!) {
    registrarDemoraInicio(input: $input) {
        idEvaluacion
    }
}`;